import { logException } from "@wss/error-tracking";
import { Throwable } from "@wss/error-tracking/throwable";
import fetchPlusModalData from "~/common/PlusSubscriptionModal/api/fetchPlusModalData";
import { PlusModalData } from "../Models";

export interface PlusModalDataExtended extends PlusModalData {
  isFreeTrialAvailable: boolean;
}

const fetchPlusModalDataExtended = async (): Promise<
  Throwable<PlusModalDataExtended>
> => {
  const result = await fetchPlusModalData();

  if (result.isError) {
    logException(result.error);

    return {
      isError: true,
      error: result.error,
    };
  }

  const { enrollmentOptions } = result.value;

  const isFreeTrialAvailable = enrollmentOptions.some(
    (promo) =>
      promo.isPromotion &&
      promo.price === 0 &&
      promo.promotionName === "First month FREE",
  );

  return {
    isError: false,
    value: {
      ...result.value,
      isFreeTrialAvailable,
    },
  };
};

export default fetchPlusModalDataExtended;
